function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useEffect } from 'react';
import { Controller, useWatch, useFormContext } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import { Select } from "../../../../../Components/Forms";
import { t, Translate } from "../../../../../../I18N";
import { relationshipTypesAtom, templatesAtom } from "../../../../../atoms";
import { orderBy } from 'lodash';







export const RelationshipFields = ({ control, disabled, templateId }) => {
  const relationshipTypes = useAtomValue(relationshipTypesAtom);
  const templates = useAtomValue(templatesAtom);
  const content = useWatch({ control, name: 'content' });
  const { setValue } = useFormContext();

  useEffect(() => {
    setValue('inherit', undefined);
  }, [content, setValue]);

  const relationshipTypeOptions = useMemo(() => {
    const options = orderBy(
      relationshipTypes.map((type) => ({
        value: type._id,
        label: t(type._id, type.name, null, false)
      })),
      'label'
    );
    options.unshift({ value: '', label: t('System', 'Select...', null, false) });
    return options;
  }, [relationshipTypes]);

  const entityOptions = useMemo(() => {
    const options = orderBy(
      templates.
      filter((template) => template._id !== templateId).
      map((template) => {
        const name =
        template.name.length > 30 ? `${template.name.slice(0, 30)}...` : template.name;
        const translatedName = t(template._id, template.name, null, false, 30);

        const label = `${name === translatedName ? name : `${name} (${translatedName})`}`;
        return {
          value: template._id,
          label
        };
      }),
      'label'
    );

    options.unshift({ value: '', label: t('System', 'Any entity', null, false) });
    return options;
  }, [templates, templateId]);

  const selectedTemplate = useMemo(() => {
    if (content === '') return null;
    return templates.find((template) => template._id === content);
  }, [content, templates]);

  const propertyOptions = useMemo(() => {
    if (!(selectedTemplate !== null && selectedTemplate !== void 0 && selectedTemplate.properties)) return [];
    const options = orderBy(
      selectedTemplate.properties.map((prop) => ({
        value: String(prop._id || ''),
        label: t(selectedTemplate._id, prop.label, null, false, 100),
        type: prop.type
      })),
      'label'
    );

    options.unshift({ value: '', label: t('System', 'Select...', null, false), type: undefined });
    return options;
  }, [selectedTemplate]);

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx(Controller, {
      name: "relationType",
      control: control,
      rules: { required: true },
      render: ({ field }) => /*#__PURE__*/
      React.createElement(Select, _extends({
        id: "property-relation-type",
        label: /*#__PURE__*/
        _jsx("div", { className: "flex items-center gap-1" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Relationship type"), /*#__PURE__*/
        _jsx("span", {}, void 0, "*")
        ),

        options: relationshipTypeOptions,
        disabled: disabled },
      field)
      ) }

    ), /*#__PURE__*/

    _jsx(Controller, {
      name: "content",
      control: control,
      rules: { required: false },
      render: ({ field }) => /*#__PURE__*/
      React.createElement(Select, _extends({
        id: "property-entity",
        label: /*#__PURE__*/
        _jsx("div", { className: "flex items-center gap-1" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Entities")
        ),

        options: entityOptions,
        disabled: disabled },
      field)
      ) }

    ),

    selectedTemplate && /*#__PURE__*/
    _jsx(Controller, {
      name: "inherit",
      control: control,
      render: ({ field }) => {var _field$value;return (/*#__PURE__*/
          _jsx(Select, {
            id: "property-inherit",
            label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Inherit property"),
            options: propertyOptions,
            disabled: disabled,
            onChange: (e) => {
              const { value } = e.target;
              const option = propertyOptions.find((opt) => opt.value === value);
              if (option && option.type) {
                field.onChange({ property: value, type: option.type });
              } else {
                field.onChange(undefined);
              }
            },
            value: ((_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.property) || '' }
          ));} }

    )

    ));

};